
import { Campaign } from "@/hooks/useCampaigns";
import { AlertCircle, Loader2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeleteCampaignDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  campaign: Campaign | null;
  isProcessing: boolean;
  onConfirm: () => void;
}

export function DeleteCampaignDialog({
  open,
  onOpenChange,
  campaign,
  isProcessing,
  onConfirm
}: DeleteCampaignDialogProps) {
  if (!campaign) return null;
  
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center text-destructive">
            <AlertCircle className="mr-2 h-5 w-5" /> Delete Campaign
          </AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete "{campaign.title}"?
            <br /><br />
            This action cannot be undone and will delete all associated vouchers.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isProcessing}>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isProcessing}
            className="flex items-center bg-destructive hover:bg-destructive/90"
          >
            {isProcessing && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {isProcessing ? "Deleting..." : "Delete Campaign"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
